var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIos03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 180,
    viewBox: "0 0 227 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1466_184491)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 226.667,
    height: 180,
    rx: 7.05882,
    fill: "#EEF5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 186,
    height: 229,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 24,
    width: 170,
    height: 27,
    rx: 13.5,
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 56,
    width: 170,
    height: 139,
    rx: 12,
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 27,
    width: 21,
    height: 21,
    rx: 10.4707,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 27,
    width: 21,
    height: 21,
    rx: 10.4707,
    fill: "#5E7DE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.184 34.875L184.496 33.5625M184.496 33.5625L185.809 34.875M184.496 33.5625V37.9375M182.309 36.625C181.901 36.625 181.697 36.625 181.536 36.6916C181.322 36.7804 181.152 36.9509 181.063 37.1653C180.996 37.3261 180.996 37.5298 180.996 37.9375V40.0375C180.996 40.5275 180.996 40.7724 181.091 40.9596C181.175 41.1242 181.309 41.2583 181.474 41.3422C181.661 41.4375 181.906 41.4375 182.395 41.4375H186.598C187.087 41.4375 187.331 41.4375 187.518 41.3422C187.683 41.2583 187.817 41.1242 187.901 40.9596C187.996 40.7726 187.996 40.5279 187.996 40.0389V37.9375C187.996 37.5298 187.996 37.3261 187.929 37.1653C187.841 36.9509 187.67 36.7804 187.456 36.6916C187.295 36.625 187.091 36.625 186.684 36.625",
    stroke: "white",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1466_184491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 226.667,
    height: 180,
    rx: 7.05882,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos03);
export default __webpack_public_path__ + "static/media/ios03.7389c6820242d304a07ab54101d31810.svg";
export { ForwardRef as ReactComponent };